export enum MerchantKnowledgeOrigin {
  Merchant = "MERCHANT",
  AiSuggested = "AI_SUGGESTED",
  Scraped = "SCRAPED",
  Imported = "IMPORTED",
}
